import { useUiLanguage } from "@/i18n/useUiLanguage";
import { systemText, tr } from "@/i18n/copy";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { QrCode, Loader2 } from "lucide-react";
import { publicApi, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ClientInvitationAccept() {
  useUiLanguage();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { login } = useAuth();
  const token = params.get("token") || "";
  const [invite, setInvite] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) { setError(tr("Link di invito non valido.")); return; }
    publicApi.get(`/auth/client-invitations/preview?token=${encodeURIComponent(token)}`)
      .then(setInvite)
      .catch((e) => setError(errMsg(e)));
  }, [token]);

  const accept = async () => {
    if (saving) return;
    setError("");
    if (password.length < 12) { setError(tr("La password deve contenere almeno 12 caratteri.")); return; }
    if (password !== confirm) { setError(tr("Le password non coincidono.")); return; }
    setSaving(true);
    try {
      await publicApi.post("/auth/client-invitations/accept", { token, password });
      try {
        if (!invite.studio_slug) throw new Error(tr("Apri l’app del tuo Studio per accedere."));
        await login(invite.email, password, undefined, invite.studio_slug);
        // Start a canonical client document so installation metadata is Studio-scoped.
        window.location.replace(`/client?studio=${encodeURIComponent(invite.studio_slug)}`);
        return;
      } catch {
        setDone(true);
      }
    } catch (e) { setError(errMsg(e)); }
    finally { setSaving(false); }
  };

  return <main className="min-h-screen bg-background text-foreground grid place-items-center p-5">
    <Card className="w-full max-w-lg p-6 sm:p-8 bg-card/90">
      <div className="flex items-center gap-3"><div className="grid h-11 w-11 place-items-center rounded-xl bg-primary/15"><QrCode className="h-5 w-5 text-primary" /></div><div><p className="label-tiny text-primary">{tr("Tattoo Pro Studio")}</p><h1 className="font-display text-2xl font-bold">{tr("Attiva profilo Cliente")}</h1></div></div>
      {!invite && !error && <div className="mt-8 flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="h-4 w-4 animate-spin" />{tr("Verifica invito…")}</div>}
      {error && <div className="mt-6 rounded-xl border border-destructive/30 bg-destructive/10 p-4 text-sm text-destructive">{systemText(error)}</div>}
      {invite && !done && <div className="mt-7 space-y-5"><div className="rounded-2xl border bg-background/50 p-4"><p className="text-sm">{tr("Ciao")} <strong>{invite.name || tr("Cliente")}</strong>, <strong>{invite.studio_name}</strong> {tr("ti invita ad attivare la tua app cliente.")}</p><p className="mt-2 text-sm text-muted-foreground">{tr("Account:")} {invite.email}</p></div><div><Label>{tr("Password per questo Studio")}</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" placeholder={tr("Almeno 12 caratteri")} /></div><div><Label>{tr("Conferma password")}</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5" /></div><Button className="w-full" disabled={saving} onClick={accept}>{saving ? tr("Attivazione…") : tr("Attiva il mio profilo")}</Button></div>}
      {done && <div className="mt-7 space-y-5"><div className="rounded-2xl border border-emerald-500/30 bg-emerald-500/10 p-4"><h2 className="font-semibold">{tr("Profilo Cliente attivato")}</h2><p className="mt-1 text-sm text-muted-foreground">{tr("Ora puoi accedere alla PWA del tuo Studio, richiedere appuntamenti e usare il tuo QR ID Cliente.")}</p></div><Button className="w-full" onClick={() => nav(invite?.studio_slug ? `/studio/${invite.studio_slug}/login` : "/")}>{tr("Vai all'App dello Studio")}</Button></div>}
    </Card>
  </main>;
}


